import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.2 17.8" {...props}><path d="M17.3 17.3L31.6 3c.7-.7.7-1.8 0-2.5-.3-.3-.7-.5-1.2-.5s-.9.2-1.2.5L16.1 13.6 3 .5C2.7.2 2.2 0 1.8 0 1.3 0 .8.2.5.5.2.9 0 1.3 0 1.8c0 .4.2.9.5 1.2l14.3 14.3c.7.7 1.8.7 2.5 0z" /></svg>;